<template>
  <div class="w-full md:w-1/2 lg:w-1/2 xl:w-1/2 p-6 flex flex-col">
      <ShowInOpenseaLink :tokenId="tokenId" />

    <div class="iframe1by1 shadow-lg hover:grow hover:shadow-lg">
      <iframe
        v-if="contentUri != ''"
        scrolling="no"
        sandbox="allow-same-origin allow-scripts"
        :src="httpUri(contentUri)"
      ></iframe>
    </div>

    <div class="pt-3">
      
        <a
          class="text-gray-800 block underline hover:text-gray-900"
          :href="httpUri(contentUri)"
          target="_blank"
          >{{ metadata.name }}</a>
      
      
     
    </div>
    <div class="pt-1 text-gray-900">
        Will be available on auction to be announced

        <div class="flex items-center justify-center">
        <svg
          version="1.1"
          class="h-4"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 128 128"
          xml:space="preserve"
        >
          <g>
            <path
              fill="#ED6C30"
              d="M98.59,51.16c-4.23,0.92-7.88,3.28-9.59,7.35c-1.029,2.47-2.471,8.85-6.42,7.2
		c-1.891-0.78-1.859-3.49-1.641-5.18c0.471-3.47,2.031-6.64,3.101-9.94c1.101-3.42,2.05-6.86,2.729-10.4
		c2.28-11.72,1.65-25.22-6.64-34.59C78.73,4,75.2,0.3,72.87,0.22c-1.44-0.04-0.021,1.66,0.38,2.23c0.811,1.17,1.49,2.44,2.01,3.77
		c6.131,15.64-8.98,27.55-18.91,36.82c-4.76,4.45-8.56,9.17-11.98,14.68c-0.34,0.53-1.09,2.311-2.06,1.94
		c-1.15-0.44-1.27-3.07-1.63-4.05c-0.68-1.88-1.73-3.93-3.08-5.4c-2.61-2.86-6.26-4.79-10.21-4.53c-0.15,0.01-0.58,0.08-1.11,0.2
		c-0.83,0.18-3.05,0.47-2.45,1.81c0.31,0.69,1.22,0.63,1.87,0.82c8.34,2.56,8.15,11.3,6.8,18.32c-2.44,12.779-9.2,24.859-4.4,38
		c5.66,15.49,23.38,25.16,39.46,22.5c4.39-0.721,9.449-2.141,13.39-4.26c4.19-2.26,8.78-5.351,12.05-8.83
		c4.21-4.471,6.891-10.2,7.68-16.271c0.93-7.02-1.31-13.64-3.35-20.27c-2.46-8-5.29-21.06,4.93-24.97c0.5-0.2,1.5-0.35,1.85-0.88
		C105.41,49.91,99.17,51.04,98.59,51.16z"
            />
            <path
              fill="#FCC21B"
              d="M68.13,106.07c2.12,1.779,5.091,0.91,7.091-0.61c1.069-0.81,1.989-1.851,2.59-3.06
		c0.25-0.521,0.539-1.181,0.539-1.771c0-0.79-0.47-1.569-0.27-2.38c1.68-0.33,3.76,4.5,3.97,5.62
		c1.681,8.83-6.64,16.11-14.67,17.521c-13.55,2.369-21.34-9.5-19.78-20.041c0.97-6.56,5.37-11.069,9.85-15.569
		C61.16,82.05,64.6,78.85,65.8,74c0.21-0.859,0.16-2.18-0.09-3.029c-0.21-0.73-0.61-1.4-0.63-2.19c-0.061-1.66,1.55,0.51,1.92,0.93
		c4.46,5.03,5.73,12.46,4.54,18.96c-0.771,4.2-3.771,7.2-4.819,11.221C66.109,102.18,66.17,104.41,68.13,106.07z"
            />
          </g>
        </svg>

        <small v-if="collection" class="text-gray-600"
          >Token owner receive Ξ
          {{ web3Dapp.utils.fromWei(collection.balance, "ether") }} if burned
          next</small>
      </div>
   
      <div class="sm:ml-3">
        <button
          @click="burn"
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Burn
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import NftMixins from './mixins/NftMixins.js'

export default {
  name: "NftWithdrawOnBurn",
  mixins:[NftMixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iframe1by1 {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 100%;

  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}

.iframe1by1 > iframe {
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;

  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}

.hover\:grow {
  transition: all 0.3s;
  transform: scale(1);
}

.hover\:grow:hover {
  transform: scale(1.02);
}
</style>
